/** 유저정보 */
export const GET_USER_INFO = "get-user-info";

/** 사용자 차량 정보 저장 */
export const POST_USER_DRIVER_QUALIFICATION = "/user/driver-qualification";

/** 사용자 회원가입시, 이미지 저장 */
export const POST_USER_DRIVER_QUALIFICATION_IMAGE =
  "/user/driver-qualification/image";

/** 사용자 이미지 조회 */
export const GET_USER_DRIVER_QUALIFICATION_IMAGE =
  "/user/driver-qualification/image/";

/** 사용자 ID 중복 체크 */
export const GET_USER_ID_CHECK = "/user/check-user-id";

/** 회원가입 */
export const POST_USER_INFO = "/user/user-info";

/** 사용자 정보 수정 */
export const PUT_USER_INFO = "/user/user-info-edit";

/** 사용자 운송, 요금 합계 정보 */
export const GET_USER_TRANSPORT = "/user/transport-info";

/** 사용자 프로필 사진 등록 */
export const POST_USER_PROFILE_IMAGE = "/user/profile/image";

/** 기사 인증정보 조회 */
export const DRIVER_CERTIFICATION_INFO = "/user/driver-certification-info";

/** 진행중인 운송항목 리스트 조회 */
export const ONGOING_TRANSPORTATIONS = "/transportation/ongoing/list";

/** 진행중인 운송항목 도착지까지 네비게이션 데이터 조회 */
export const ONGOING_MAP = "/transportation/ongoing/map";

/** 운송정보(대기중) 조회 */
export const STANDBY_TRANSPORTATIONS = "/transportation/standby";

/** 운송 수락 */
export const ACCEPT_MATCH_TRANSPORTATIONS = "/transportation/accept-match";

/** 차량 정보 조회 */
export const VEHICLE_USER = "/user/vehicle";

/** 상차지 이동 */
export const ONGOING_DETAIL = "/transportation/ongoing/detail";

/** 운송 이미지 등록 */
export const CHECK_IMAGE = "transportation/check-list/image";

/** 운송체크 이미지 등록 */
export const CHECK_TRANSPORTATION_IMAGE_SAVE = "transportation/check-img-save";

/** 운송체크 이미지 삭제 */
export const CHECK_TRANSPORTATION_IMAGE_DELETE =
  "transportation/check-img-delete";

/** 운송체크 다음항목으로 이동 */
export const CHECK_NEXT_PAGE = "/transportation/check-list/next-level";

/** 운송체크 현재 단계 이미지 업로드 검사 */
export const CHECK_CURRENT_IMAGE_UPLOAD =
  "/transportation/check-list/current-image-upload";

  /** 운송 이미지 조회 */
  export const CHECK_IMAGE_INFO = "transportation/check-list/image-info";

/** 인수증 이미지 조회 */
export const RECEIPT_IMAGE_INFO = "transportation/receipt/image-info";

/** 내 운송 기록 조회 ( 운송 완료 기록 ) */
export const MY_COMPLETED_TRANSPORTATION_LIST = "transportation/completed";

/** 회원 탈퇴 */
export const USER_WITHDRAWAL = "/user/withdrawal";

/** [메인화면] 전월 대비 운송 실적 가시화 데이터 */
export const TRANSPORTATIONS_PERFORMANCE = "/transportation/performance";
